import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatDate, openPortal } from "@/lib/billing";
import { toast } from "sonner";
import { formatApiError } from "@/lib/api";

export function BillingBanner() {
  const { user } = useAuth();
  const b = user ? user.billing : undefined;
  if (!b || !["expired", "past_due", "canceling"].includes(b.status)) return null;
  const text = b.status === "expired" ? "Tu suscripción venció. Puedes ver y descargar tus datos, pero no registrar ni usar el mentor."
    : b.status === "past_due" ? `No pudimos cobrar tu suscripción. Stripe lo reintentará en los próximos días; actualiza tu tarjeta antes del ${formatDate(b.grace_end)} para no perder el acceso.`
    : `Cancelaste tu suscripción. Tienes acceso completo hasta el ${formatDate(b.current_period_end)}.`;
  return (
    <div className={`border-b px-4 py-3 text-sm sm:px-8 ${b.status === "canceling" ? "border-[#FDE68A] bg-[#FFFBEB] text-amber-900" : "border-rose-200 bg-rose-50 text-rose-800"}`} data-testid="billing-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center gap-3">
        <AlertTriangle className="h-4 w-4 shrink-0" /><span className="flex-1">{text}</span>
        {b.status === "past_due" ? (
          <button type="button" onClick={() => openPortal().catch((e) => toast.error(formatApiError(e)))} className="rounded-full bg-[#1B2A4A] px-4 py-1.5 text-xs font-semibold text-white" data-testid="billing-banner-action">Actualizar mi tarjeta</button>
        ) : (
        <Link to={b.status === "expired" ? "/suscripcion" : "/configuracion#suscripcion"} className="rounded-full bg-[#1B2A4A] px-4 py-1.5 text-xs font-semibold text-white" data-testid="billing-banner-action">
          {b.status === "expired" ? "Reactivar" : "Ver suscripción"}
        </Link>
        )}
      </div>
    </div>
  );
}
